import type { FeatureFlagService } from "../../services/feature-flags";
import { parseTrainingMarkdown } from "./parser";
import type { ParseResult } from "./parser";

export interface ParserDisabled {
  readonly ok: false;
  readonly error: {
    readonly code: "FEATURE_DISABLED";
    readonly message: string;
  };
}

export type GatedParseResult = ParseResult | ParserDisabled;

export function parseOrdersWhenEnabled(
  source: string,
  flags: FeatureFlagService,
): GatedParseResult {
  if (!flags.isEnabled("ordersReaderParser")) {
    return {
      ok: false,
      error: {
        code: "FEATURE_DISABLED",
        message: "The Orders Reader parser is disabled in this build.",
      },
    };
  }

  return parseTrainingMarkdown(source);
}
